import React from "react";

var connected = false;
var menu = 0;

const Gamepad = (props) => {
  var interval;
  // if (!('GamepadEvent' in window)) {
  //   // No gamepad events available, poll instead.
  //   var interval = setInterval(pollGamepads, 500);
  // }

  // function pollGamepads() {

  //   gameLoop();
  //   //  var start = rAF(gameLoop);
  //   clearInterval(interval);
  // }

  function buttonPressed(b) {
    if (typeof b == "object") {
      return b.pressed;
    }
    return b == 1.0;
  }
  var press = false;

  function gameLoop() {
    clearInterval(interval);
    // alert("gameloop");
    var gamepads = navigator.getGamepads
      ? navigator.getGamepads()
      : navigator.webkitGetGamepads
      ? navigator.webkitGetGamepads
      : [];
    if (!gamepads) return;
    //var press = false;
    var gp = gamepads[0];
    if(gamepads.length>1)
    {
      gp = gamepads[1];
    }

    var g_Command;
    //  console.log(gp);

    if (gp != null && !press) {
      //mini
      // if (gp.id.search("3232") > -1 || gp.id.search("8Bitdo") > -1) {
      if (true) {
        if (menu == 0) {
          if (gp.axes[0] == -1) {
            //gamepads[0].axes[0] = 0;
            props.GamepadPressed("left");
            press = true;
          }
          if (gp.axes[0] > 0) {
            //      if (gp.axes[0] == 1) {
            props.GamepadPressed("right");
            press = true;
          }
          if (gp.axes[1] > 0) {
            //if (gp.axes[1] == 1) {
            props.GamepadPressed("down");
            press = true;
          }
          if (gp.axes[1] == -1) {
            props.GamepadPressed("up");
            press = true;
          }
          if (buttonPressed(gp.buttons[0])) {
            props.GamepadPressed("Y");
            press = true;
          }
          if (buttonPressed(gp.buttons[1])) {
            props.GamepadPressed("B");
            press = true;
          }
          if (buttonPressed(gp.buttons[2])) {
            props.GamepadPressed("A");
            press = true;
          }
          if (buttonPressed(gp.buttons[3])) {
            props.GamepadPressed("X");
            press = true;
          }
          if (buttonPressed(gp.buttons[4])) {
            props.GamepadPressed("L");
            menu = 1;
            press = true;
          }
          if (buttonPressed(gp.buttons[5])) {
            props.GamepadPressed("R");
            press = true;
          }
          if (buttonPressed(gp.buttons[6])) {
            alert("L");
          }
          if (buttonPressed(gp.buttons[7])) {
            alert("R");
          }
          if (buttonPressed(gp.buttons[8])) {
            props.GamepadPressed("Select");
            press = true;
          }
          if (buttonPressed(gp.buttons[9])) {
            press = true;
            props.GamepadPressed("Start");
          }
          if (buttonPressed(gp.buttons[10])) {
            props.GamepadPressed("Select");
            press = true;
          }
          if (buttonPressed(gp.buttons[11])) {
            press = true;
            props.GamepadPressed("Start");
          }
        } else {
          if (gp.axes[0] == -1) {
            //gamepads[0].axes[0] = 0;
            props.GamepadPressed("left");
            press = true;
          }
          if (gp.axes[0] > 0) {
            //      if (gp.axes[0] == 1) {
            props.GamepadPressed("right");
            press = true;
          }
          if (gp.axes[1] > 0) {
            //if (gp.axes[1] == 1) {
            // props.GamepadPressed("down");
            props.GamepadPressed("FindByLevelDown");
            press = true;
          }
          if (gp.axes[1] == -1) {
            //  props.GamepadPressed("up");
            //  props.GamepadPressed("levelup");
            props.GamepadPressed("FindByLevelUp");
            press = true;
          }
          if (buttonPressed(gp.buttons[0])) {
            props.GamepadPressed("Y");
            press = true;
          }
          if (buttonPressed(gp.buttons[1])) {
            props.GamepadPressed("B");
            press = true;
          }
          if (buttonPressed(gp.buttons[2])) {
            props.GamepadPressed("A");
            press = true;
          }
          if (buttonPressed(gp.buttons[3])) {
            props.GamepadPressed("X");
            press = true;
          }
          if (buttonPressed(gp.buttons[4])) {
            props.GamepadPressed("L");
            menu = 0;
            press = true;
          }
          if (buttonPressed(gp.buttons[5])) {
            // props.GamepadPressed("R");
            props.GamepadPressed("bookmark");
            props.GamepadPressed("R");
            press = true;
          }
          if (buttonPressed(gp.buttons[6])) {
            alert("L");
          }
          if (buttonPressed(gp.buttons[7])) {
            alert("R");
          }
          if (buttonPressed(gp.buttons[8])) {
            //   props.GamepadPressed("Select");
            props.GamepadPressed("DisableFilterByLevel");
            press = true;
          }
          if (buttonPressed(gp.buttons[9])) {
            press = true;
            // props.GamepadPressed("Start");
            props.GamepadPressed("FilterByLevel");
          }
          if (buttonPressed(gp.buttons[10])) {
            // props.GamepadPressed("Select");
            props.GamepadPressed("DisableFilterByLevel");
            press = true;
          }
          if (buttonPressed(gp.buttons[11])) {
            press = true;
            //   props.GamepadPressed("Start");
            props.GamepadPressed("FilterByLevel");
          }
        }
      }
    }
    // console.log(this);

    if (press == true) {
      //   console.log("repeat");
      clearInterval(interval);
      press = false;
      //29.12 @mar
      //  interval = setInterval(gameLoop, 200);
      interval = setInterval(gameLoop, 250);
    } else {
      clearInterval(interval);
      interval = setInterval(gameLoop, 15);
    }
  }

  var rAF =
    window.mozRequestAnimationFrame ||
    window.webkitRequestAnimationFrame ||
    window.requestAnimationFrame;

  var rAFStop =
    window.mozCancelRequestAnimationFrame ||
    window.webkitCancelRequestAnimationFrame ||
    window.cancelRequestAnimationFrame;

  window.addEventListener("gamepadconnected", function () {
    console.log("gameLoop");
    if (!connected) {
      connected = true;
      gameLoop();
    }
  });

  window.addEventListener("gamepaddisconnected", function () {
    //   gamepadInfo.innerHTML = "Waiting for gamepad.";

    rAFStop("start");
  });

  rAFStop = (start) => {
    // alert("rAFStop");
  };

  return <div></div>;
};

export default Gamepad;
